import { render, staticRenderFns } from "./ProductIngredients.vue?vue&type=template&id=133270e0&scoped=true&lang=pug&"
import script from "./ProductIngredients.vue?vue&type=script&lang=js&"
export * from "./ProductIngredients.vue?vue&type=script&lang=js&"
import style0 from "./ProductIngredients.vue?vue&type=style&index=0&id=133270e0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133270e0",
  null
  
)

export default component.exports